<template>
	<div class="upload-image">
		<el-upload :http-request="customUpload" :file-list="fileList" :on-success="handleSuccess"
			:on-remove="handleRemove" :before-upload="beforeUpload" :limit="maxCount" :on-exceed="handleExceed"
			:auto-upload="true" list-type="picture-card" action="#">
			<i class="el-icon-plus"></i>
		</el-upload>
		<div class="el-upload__tip" slot="tip">{{ tip }}</div>
	</div>
</template>

<script>
	import {
		getToken
	} from '@/utils/auth'
	// 导入封装的上传接口
	import {
		uploadFile
	} from '@/api/upload.js'

	export default {
		name: 'UploadImage',
		props: {
			value: {
				type: Array,
				default: () => []
			},
			maxCount: {
				type: Number,
				default: 5
			},
			tip: {
				type: String,
				default: '最多上传5张图片，单张不超过2MB'
			}
		},
		computed: {
			// 文件列表（回显已上传的图片）
			fileList() {
				return this.value.map(url => ({
					url
				}))
			}
		},
		methods: {
			// 自定义上传逻辑（核心：调用uploadFile接口）
			async customUpload(options) {
				try {
					// 1. 构造FormData（文件上传必须用FormData）
					const formData = new FormData()
					formData.append('file', options.file) // 字段名和后端保持一致，默认用file

					// 2. 调用封装的uploadFile接口（自动携带token，无需手动加header）
					const response = await uploadFile(formData)

					// 3. 触发el-upload的success回调，把响应传给handleSuccess
					options.onSuccess(response)
				} catch (error) {
					// 上传失败触发error回调
					options.onError(error)
					this.$message.error('图片上传失败：' + (error.message || '网络异常'))
				}
			},

			// 文件上传前校验（逻辑不变）
			beforeUpload(file) {
				const isImage = file.type.startsWith('image/')
				const isLt2M = file.size / 1024 / 1024 < 2
				if (!isImage) {
					this.$message.error('只能上传图片格式！')
					return false
				}
				if (!isLt2M) {
					this.$message.error('图片大小不能超过2MB！')
					return false
				}
				return true
			},

			handleSuccess(response) {
				if (response.code === 200) {
					const newImages = [...this.value, response.data.url]
					const imgIds = [...this.value, response.data.ossId]
					this.$emit('input', newImages)
					this.$emit('uploadSuccess', response.data)
				} else {
					this.$message.error('图片上传失败：' + (response.msg || '接口返回异常'))
				}
			},


			handleRemove(file) {
				const newImages = this.value.filter(url => url !== file.url)
				this.$emit('input', newImages)
				this.$emit('handleRemove', file)
			},


			handleExceed() {
				this.$message.error(`最多只能上传${this.maxCount}张图片！`)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.upload-image {
		width: 100%;

		.el-upload--picture-card {
			width: 100px;
			height: 100px;
		}
	}
</style>